module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iJ3VL"))).then(() => module.bundle.root('d0iPb'));